"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _antd = require("antd");
var _react = _interopRequireWildcard(require("react"));
var _locale = require("./locale");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ColorPicker = function ColorPicker(props) {
  var locale = (0, _locale.useLocale)();
  var _antdTheme$useToken = _antd.theme.useToken(),
    antdToken = _antdTheme$useToken.token;
  var presetColors = (0, _react.useMemo)(function () {
    return [antdToken.blue, antdToken.purple, antdToken.cyan, antdToken.green, antdToken.magenta, antdToken.red, antdToken.orange, antdToken.yellow, antdToken.volcano, antdToken.geekblue, antdToken.gold, antdToken.lime, '#000'];
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  return /*#__PURE__*/_react.default.createElement(_antd.ColorPicker, (0, _extends2.default)({}, props, {
    presets: [{
      label: locale.presetColors,
      colors: presetColors
    }]
  }));
};
var _default = exports.default = ColorPicker;